import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import { Search } from "lucide-react";

interface SearchInputProps {
  value?: string;
  onSearch: (value: string) => void;
  placeholder?: string;
  /** Merged onto the outer wrapper (e.g. flex sizing in toolbars). */
  wrapperClassName?: string;
}

export function SearchInput({ onSearch, value, placeholder = "Search...", wrapperClassName }: SearchInputProps) {
  return (
    <div className={cn("relative !h-auto w-full max-w-[305px]", wrapperClassName)}>
      <Search className="absolute top-1/2 left-3 -translate-y-1/2 text-gray-400" size={18} />
      <Input
        type="text"
        value={value}
        onChange={(event) => onSearch(event.target.value)}
        placeholder={placeholder}
        className="rounded-lg border border-gray-300 pl-10 focus:border-gray-500 focus:ring-1 focus:ring-gray-500"
      />
    </div>
  );
}
